const RESPONSE_TYPE = {
  ENTITY: 'ENTITY',
  CREATE_NEW_ENTITY: 'CREATE_NEW_ENTITY',
  UPDATE_ENTITY: 'UPDATE_ENTITY',
  WIDGET: 'WIDGET',
  LOOKUP_TARGETS: 'LOOKUP_TARGETS',
  CHOICE_DATA_SOURCES: 'CHOICE_DATA_SOURCES',
};

export default RESPONSE_TYPE;
